import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { NewsListSidebar } from '../../../components/NewsList';
import {
  downloadNewsCoverPhoto, previewNewsAsHTML, useSpecificNews
} from '../../../misc/lib/news';
import routes from '../../../misc/routes';
import './SpecificNewsPage.scss';

const SpecificNewsPage = () => {
  const { pathname } = useLocation();
  const [ news, newsLoading ] = useSpecificNews(
    pathname.substring(pathname.lastIndexOf('/') + 1)
  );
  const [ coverUrl, setCoverUrl ] = useState<string>();

  useEffect(() => {
    if (!news) return;

    downloadNewsCoverPhoto(news.id, news.coverPath).then((file) => {
      setCoverUrl(URL.createObjectURL(file));
    }).catch((err) => {
      console.error(err);
    });

    window.document.title = `${ news.title } - ${ routes.home.title }`;
  }, [ news ]);

  return newsLoading ? <LoadingOverlay /> : !news ? (
    <Redirect to={ routes.news.path } />
  ) : (
    <div className="specificnewspage-container">
      <img src={ coverUrl } alt="" />
      <div className="specificnewspage-news-content">
        <div className="title">
          <h1>{ news.title }</h1>
          <h2>{ news.timestamp.toDate().toLocaleDateString() }</h2>
        </div>
        <div className="body"
          dangerouslySetInnerHTML={ { __html: previewNewsAsHTML(news.body) } }></div>
        <div className="sidebar">
          <h2>További hírek</h2>
          <NewsListSidebar />
        </div>
      </div>
    </div>
  );
};

export default SpecificNewsPage;
